import React, { useEffect, useState } from "react";
import axios from "axios";
import toast from 'react-hot-toast'
import { Modal } from "flowbite";
import { useNavigate } from "react-router-dom";
// import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const Notifications = () => {

    const token = sessionStorage.getItem("bearer_token");
    const auth_token = sessionStorage.getItem("token");

    const navigate = useNavigate();

    const [users, setUsers] = useState([]);
    const [selected, setSelected] = useState([]);
    const [form, setForm] = useState({ title: '', message: '' });
    const [userType, setUserType] = useState("");

    const [notifications, setNotifications] = useState([]);

    const [refreshKey, setRefreshKey] = useState(0);

    const [filters, setFilters] = useState({
        name: "",
        page: 1,
        limit: 10,
    });

    // pagination and search
    const [notificationfilters, setNotificationFilters] = useState({
        page: 1,
        limit: 10,
    });
    const [pagination, setPagination] = useState({
        totalRecords: 0,
        currentPage: 1,
        totalPages: 0,
        limit: 0,
    });

    const permissions = JSON.parse(sessionStorage.getItem("permissions"));

    const [permissionModule, setPermissionModule] = useState([]);

    // const modules = {
    //     toolbar: [
    //         [{ 'font': [] }],
    //         [{ 'size': [] }],
    //         ['bold', 'italic', 'underline', 'strike'],
    //         [{ 'list': 'ordered' }, { 'list': 'bullet' }],
    //         [{ 'align': [] }],
    //         ['link', 'image'],
    //     ],
    // };

    useEffect(() => {
        const getUsers = async () => {
            const queryParams = Object.entries(filters)
                .filter(([_, value]) => value) // Only include parameters with non-empty values
                .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
                .join("&");
            try {
                const res = await axios.get(process.env.REACT_APP_API_URL + `api/user/get-user?${queryParams}&isSuperAgent=2`, {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`,
                        "auth_token": `${auth_token}`,
                    },
                });

                const filteredUsers = res.data.data.users;

                setUsers(filteredUsers);

            }
            catch (err) {
                if (err.response?.status === 400) {
                    // Handle invalid token error
                    if (err.response.data === "invalid token") {
                        navigate("/login"); // Redirect to login page
                    } else {
                        toast.error(err.response.data); // Show other 400 errors
                    }
                } else {
                    // Handle other errors
                    toast.error("No Users Found.");
                }
            }
        }
        getUsers();
    }, [refreshKey, filters]);

    useEffect(() => {
        const getNotifications = async () => {
            try {
                const queryParams = Object.entries(notificationfilters)
                    .filter(([_, value]) => value) // Only include parameters with non-empty values
                    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
                    .join("&");
                const res = await axios.get(process.env.REACT_APP_API_URL + `api/notifications/get-notifications?${queryParams}`, {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`,
                        "auth_token": `${auth_token}`,
                    },
                });

                if (res.data.success) {
                    setNotifications(res.data.notifications);
                    setPagination({
                        totalRecords: res.data.pagination.totalRecords,
                        currentPage: res.data.pagination.currentPage,
                        totalPages: res.data.pagination.totalPages,
                        limit: res.data.pagination.limit,
                    });
                }

            } catch (err) {
                console.error(err.response.data);
            }
        }
        getNotifications();

        if (permissions) {

            setPermissionModule(permissions.find(
                (permission) => permission.Module.moduleName === 'notifications'
            ));
        }
    }, [refreshKey, notificationfilters])

    useEffect(() => {
        if(userType === "all"){
            setSelected([]);
        }
    }, [userType])

    const handleSubmit = async (e) => {
        e.preventDefault();

        const payload = {
            ...form,
            userIds: selected.length === 0 ? null : selected,
        };

        try {
            const res = await axios.post(process.env.REACT_APP_API_URL + "api/notifications/create-notification", payload, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                    "auth_token": `${auth_token}`,
                },
            });

            setRefreshKey((prevKey) => prevKey + 1);
            toast.success(res.data.message);
            setSelected([]);
            setForm({ title: '', message: '' });


        } catch (err) {
            if (err.response?.status === 400) {
                // Handle invalid token error
                if (err.response.data === "invalid token") {
                    navigate("/login"); // Redirect to login page
                } else {
                    toast.error(err.response.data); // Show other 400 errors
                }
            } else {
                // Handle other errors
                toast.error("An unexpected error occurred.");
            }
        }
    };

    const readNotification = async (notificationId) => {
        try {
            const postData = {
                "id": notificationId,
            }
            const res = await axios.put(process.env.REACT_APP_API_URL + `api/notifications/read-notification`, postData, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                    "auth_token": `${auth_token}`,
                },
            });

            if (res.data.success) {
                toast.success("Marked as Read!");
                setRefreshKey((prevKey) => prevKey + 1);

            }
        } catch (err) {
            if (err.response?.status === 400) {
                // Handle invalid token error
                if (err.response.data === "invalid token") {
                    sessionStorage.clear();
                    navigate("/"); // Redirect to login page
                } else {
                    console.error(err.response.data); // Show other 400 errors
                }
            }
        }
    }

    const toggleSelect = (id) => {
        setSelected(prev =>
            prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]
        );
    };

    const handleFilterChange = (key, value) => {
        setFilters((prev) => ({
            ...prev,
            [key]: value,
            page: 1, // Reset to the first page on filter change
        }));
    };

    const handlePageChange = (newPage) => {
        setNotificationFilters((prev) => ({ ...prev, page: newPage }));
    };

    useEffect(() => {
        // Initialize the modal on component mount
        const createElement = document.getElementById("popup-modal");
        if (createElement) {
            const create_modal = new Modal(createElement);
            create_modal.hide(); // Ensure the modal is initially hidden
        }
    }, []);

    const formatDate = (dateString) => {
        const date = new Date(dateString.replace(" ", "T")); // Replace space with T for compatibility
        const options = { month: 'long', day: 'numeric', year: 'numeric' };
        const formattedDate = date.toLocaleDateString('en-US', options);
        const time = date.toLocaleTimeString('en-US', { hour12: false });
        return `${formattedDate} ${time}`;
    };

    return (
        <div className="bg-gray-100">
            <div className="py-20 sm:ml-64 p-6 rounded-lg shadow-md">

                <div className="md:flex justify-between py-5">

                    {
                        permissionModule.canCreate &&
                        <button type="button"
                            onClick={() => {
                                const createElement = document.getElementById("popup-modal");
                                if (createElement) {
                                    const create_modal = new Modal(createElement);
                                    create_modal.show();
                                }
                            }}
                            className="flex text-white bg-black rounded-full px-5 py-2 my-5">Create New Notification</button>
                    }
                </div>
                <div className="bg-white p-6 rounded-lg shadow-md ">
                    <h2 className="text-xl md:text-3xl text-left font-semibold mb-10">Sent Notifications</h2>
                    <div className="overflow-x-auto">
                        <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                            <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                                <tr>
                                    <th scope="col" className="px-6 py-3 whitespace-normal break-words">Title</th>
                                    <th scope="col" className="px-6 py-3 whitespace-normal break-words">Message</th>
                                    <th scope="col" className="px-6 py-3 whitespace-normal break-words">Date</th>
                                    <th scope="col" className="px-6 py-3 whitespace-normal break-words">Recipients</th>
                                    <th scope="col" className="px-6 py-3 whitespace-normal break-words">Read Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {notifications.length > 0 ? (
                                    permissionModule.canRead ? notifications.map((notif) => (
                                        <tr key={notif.id} className="odd:bg-white odd:dark:bg-gray-900 even:bg-gray-50 even:dark:bg-gray-800 border-b dark:border-gray-700">

                                            <td className="px-6 py-4 whitespace-normal break-words">{notif.title ? notif.title : "N/A"}</td>
                                            <td className="px-6 py-4 whitespace-normal break-words" dangerouslySetInnerHTML={{
                                                __html: notif.message
                                                    ? notif.message.replace(/\n/g, '<br />')
                                                    : '',
                                            }}></td>
                                            <td className="px-6 py-4 whitespace-normal break-words">{formatDate(notif.notificationDate)}</td>
                                            <td className="px-6 py-4 whitespace-normal break-words">{notif.userId === null ? 'All Users' : `${notif.User ? notif.User.name : "N/A"}`}</td>
                                            {notif.userId === null && !notif.readStatus ? <td className="px-6 py-4 whitespace-normal break-words">
                                                <button
                                                    onClick={() => readNotification(notif.id)}
                                                    className="mt-2 sm:mt-0  cursor-pointer bg-black text-white text-sm px-4 py-2 rounded-full"
                                                >
                                                    Mark as Read
                                                </button>
                                            </td>
                                                :
                                                <td className="px-6 py-4 whitespace-normal break-words">{notif.readStatus ? "Read" : "Unread"}</td>
                                            }
                                        </tr>

                                    )) : "Access Denied"
                                ) : (
                                    <tr>
                                        <td colSpan="4" className="text-center py-4 whitespace-normal break-words">No Notifications Found.</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>

                        {/* Pagination */}
                        <div className="flex justify-center my-4">
                            <button
                                onClick={() => handlePageChange(notificationfilters.page - 1)}
                                disabled={notificationfilters.page === 1}
                                className="text-white py-1 px-4 bg-black rounded-full mx-1"
                            >
                                Previous
                            </button>
                            <span className="px-4 py-2 mx-1 font-medium">
                                Page {pagination.currentPage} of {pagination.totalPages}
                            </span>
                            <button
                                onClick={() => handlePageChange(notificationfilters.page + 1)}
                                disabled={notificationfilters.page === pagination.totalPages}
                                className="text-white py-1 px-4 bg-black rounded-full mx-1"
                            >
                                Next
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div
                id="popup-modal"
                tabIndex={-1}
                className="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full"
            >
                <div className="relative p-4 w-full max-w-4xl max-h-[60%]">
                    <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
                        <button
                            type="button"
                            className="absolute top-3 end-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                            onClick={() => {
                                const createElement = document.getElementById("popup-modal");
                                if (createElement) {
                                    const create_modal = new Modal(createElement);
                                    create_modal.hide();
                                }
                            }}
                        >
                            <svg
                                className="w-3 h-3"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 14 14"
                            >
                                <path
                                    stroke="currentColor"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                                />
                            </svg>
                            <span className="sr-only">Close modal</span>
                        </button>
                        <div className="p-4  text-center">
                            <div className=" p-6 bg-white shadow rounded-lg">
                                <h2 className="text-2xl font-bold text-center mb-6">Create New Notification</h2>
                                <form onSubmit={handleSubmit} className="space-y-4">


                                    <div className="mb-5 space-y-3 text-left">
                                        <label className="text-lg font-semibold">Title</label>
                                        <input
                                            type="text"
                                            className="w-full mb-1 p-2 border-2 rounded-xl"
                                            placeholder="Notification Title"
                                            value={form.title}
                                            onChange={(e) => setForm({ ...form, title: e.target.value })}
                                            required
                                        />
                                    </div>

                                    <div className="space-y-3 text-left">
                                        <p className="text-black text-lg font-semibold">Type</p>
                                        <select
                                            value={userType}
                                            onChange={(e) => setUserType(e.target.value)}
                                            className="border-2 rounded-xl px-3 py-2"
                                        >
                                            <option value="all">All Users</option>
                                            <option value="individual">Individual or Multiple</option>
                                        </select>
                                    </div>

                                    {
                                        userType === "individual" &&

                                        <div className="space-y-3 text-left">
                                            <label className="text-lg text-left font-semibold">Select Users</label>
                                            <input
                                                type="text"
                                                placeholder="Search by Name"
                                                value={filters.name}
                                                onChange={(e) => handleFilterChange("name", e.target.value)}
                                                className="flex space-y-3 border-2 rounded-xl px-3 py-2"
                                            />

                                            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 overflow-y-auto">
                                                {users.map(user => (
                                                    <label key={user.id} className="flex items-center space-x-2 text-md whitespace-normal break-words">
                                                        <input
                                                            type="checkbox"
                                                            checked={selected.includes(user.id)}
                                                            onChange={() => toggleSelect(user.id)}
                                                        />
                                                        <span>{user.name}</span>
                                                    </label>
                                                ))}
                                            </div>
                                        </div>
                                    }

                                    <div className="space-y-3 text-left">
                                        <label className="text-lg text-left font-semibold">Message</label>
                                        {/* <ReactQuill
                                            theme="snow"
                                            modules={modules}
                                            value={form.message}
                                            onChange={value => setForm({ ...form, message: value })}
                                            className="w-full border-2 rounded-xl"
                                            placeholder="Notification Message"
                                        /> */}
                                        <textarea
                                            value={form.message}
                                            onChange={(e) => setForm({ ...form, message: (e.target.value) })}
                                            className="w-full border-2 rounded-xl"
                                            placeholder="Notification Message"
                                        />
                                    </div>

                                    <div className="mt-5 flex justify-end">

                                        <button
                                            type="submit"
                                            className="bg-black cursor-pointer text-white px-4 py-2 rounded-full"
                                        >
                                            Send Notifications
                                        </button>
                                    </div>


                                </form>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Notifications;